/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function($, Drupal) {
  // CPE results toggle.
  Drupal.behaviors.cpeToggle = {
    attach: function(context, settings) {
      var $cpeToggle = $('.section-item--subtable-toggle a', context);
      $(once('cpeToggle', $cpeToggle)).each(function() {
        $(this).on('click', function(e, context) {
          e.preventDefault();

          $(this)
            .closest('.section-wrapper--subtable')
            .closest('tr')
            .next('tr')
            .find('td .pseudo-subtable__container')
            .toggleClass('closed');
        });
      });
    }
  };
})(jQuery, Drupal);
